export default () => {
  console.log(
    '%cby%c/nk%c —— estudionk.com',
    'background: rgba(256,256,256,.05); font-size: 10px; color: #131918; padding: 3px 0; padding-left: 10px;',
    'background: rgba(256,256,256,.05); font-size: 10px; color: #00FFC2; padding: 3px 0;',
    'background: rgba(256,256,256,.05); font-size: 10px; color: #131918; padding: 3px 0; padding-right: 10px;'
  );
};
